import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import VehicleDetail from "@/pages/VehicleDetail";
import Enquiry from "@/pages/Enquiry";
import FAQ from "@/pages/FAQ";
import Terms from "@/pages/Terms";
import Trips from "@/pages/Trips";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/vehicles/:code" element={<VehicleDetail />} />
            <Route path="/vehicles/:code/book" element={<Navigate to="/enquiry" replace />} />
            <Route path="/enquiry" element={<Enquiry />} />
            <Route path="/where-to-go" element={<Trips />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}
